import { render, staticRenderFns } from "./specialPersonal.vue?vue&type=template&id=65dcc95c"
import script from "./specialPersonal.vue?vue&type=script&lang=js"
export * from "./specialPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports